import { PlusIcon, TrashIcon } from '@heroicons/react/24/outline'
import { accountTypeWithBorrower, InputType, IViewOnlyLogicCondition } from 'config'
import { useProductTypeOptions } from 'hooks/useProductTypeOptions'
import { store } from 'reducers'
import { RenderInput } from 'utils/RenderInput'

const emptyCondition = (): IViewOnlyLogicCondition => ({
  productTypes: {},
  loanStatus: {},
  accountTypes: {},
})

export const ViewOnlyConditions = ({
  value,
  onChange,
  input,
}: {
  value?: IViewOnlyLogicCondition[]
  onChange: Function
  input: InputType
}) => {
  const { loanGlobalStatus } = store.getState()
  const { optionsMap: productTypeOptionsMap } = useProductTypeOptions()
  const items: IViewOnlyLogicCondition[] = Array.isArray(value) ? value : []

  const onAdd = () => {
    onChange([...items, emptyCondition()])
  }

  const onRemove = (index: number) => {
    onChange(items.filter((_, idx) => idx !== index))
  }

  const onChangeItem = (index: number, key: keyof IViewOnlyLogicCondition, newValue: Record<string, boolean>) => {
    onChange(items.map((item, idx) => (idx === index ? { ...item, [key]: newValue } : item)))
  }

  return (
    <div>
      <div className="flex items-center gap-2 mb-2 text-sm font-semibold">
        <span>{input.title || 'View only Conditions'}</span>
        <button type="button" className="btn-icon" onClick={onAdd}>
          <PlusIcon className="h-4 w-4" />
        </button>
      </div>

      {items.map((item, index) => {
        const inputs: Record<string, InputType> = {
          productTypes: {
            inputType: 'multiselect',
            title: 'Product Type',
            options: productTypeOptionsMap,
            defaultSelected: false,
            value: item.productTypes || {},
            sort: false,
          },
          loanStatus: {
            inputType: 'multiselect',
            title: 'Loan Status',
            options: loanGlobalStatus,
            defaultSelected: false,
            value: item.loanStatus || {},
            sort: false,
          },
          accountTypes: {
            inputType: 'multiselect',
            title: 'Account Types',
            options: accountTypeWithBorrower(),
            defaultSelected: false,
            value: item.accountTypes || {},
            sort: false,
          },
        }

        return (
          <div key={index} className="border border-gray-200 rounded p-2 mb-3">
            <div className="flex justify-between mb-2">
              <span className="text-sm font-semibold">Condition {index + 1}</span>
              <button type="button" className="btn-icon" onClick={() => onRemove(index)}>
                <TrashIcon className="h-4 w-4 text-rose-600" />
              </button>
            </div>

            {Object.keys(inputs).map((key) => (
              <div key={key} className="mb-2">
                <RenderInput
                  Key={`viewOnlyLogic-${index}-${key}`}
                  input={inputs[key]}
                  onChange={(_key: string, nextValue: any) =>
                    onChangeItem(index, key as keyof IViewOnlyLogicCondition, nextValue)
                  }
                />
              </div>
            ))}
          </div>
        )
      })}
    </div>
  )
}
